import { SASReportElement } from './SASReportElement';
import { SASReportObjectElement } from './SASReportObjectElement';
import { SASReportPageElement } from './SASReportPageElement';

export { SASReportElement, SASReportObjectElement, SASReportPageElement };

customElements.define('sas-report', SASReportElement);
customElements.define('sas-report-object', SASReportObjectElement);
customElements.define('sas-report-page', SASReportPageElement);
